import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DesbloqueioCreateRequest, DesbloqueioDecisaoRequest, DesbloqueioListResponse, TipoRegistro } from '@/models/desbloqueio.model';
import { EnvironmentConfig } from '@/configs/environment.config';

@Injectable({
    providedIn: 'root'
})
export class DesbloqueioService {
    private readonly API_URL = inject(EnvironmentConfig).getApiUrl() + '/desbloqueios';

    // Subject para notificar mudanças nos desbloqueios
    private readonly _onDesbloqueioChange = new Subject<void>();
    readonly onDesbloqueioChange$ = this._onDesbloqueioChange.asObservable();

    constructor(private http: HttpClient) {}

    criar(request: DesbloqueioCreateRequest): Observable<void> {
        return this.http.post<void>(this.API_URL, request).pipe(tap(() => this.notifyChange()));
    }

    listarPendentes(tipoRegistro: TipoRegistro): Observable<DesbloqueioListResponse[]> {
        return this.http.get<DesbloqueioListResponse[]>(`${this.API_URL}/pendentes/${tipoRegistro}`);
    }

    listarTodos(tipoRegistro: TipoRegistro): Observable<DesbloqueioListResponse[]> {
        return this.http.get<DesbloqueioListResponse[]>(`${this.API_URL}/todos/${tipoRegistro}`);
    }

    decisao(request: DesbloqueioDecisaoRequest): Observable<void> {
        return this.http.post<void>(`${this.API_URL}/decisao`, request).pipe(tap(() => this.notifyChange()));
    }

    historico(registroId: string): Observable<DesbloqueioListResponse[]> {
        return this.http.get<DesbloqueioListResponse[]>(`${this.API_URL}/historico/${registroId}`);
    }

    cancelar(identificador: string): Observable<void> {
        return this.http.delete<void>(`${this.API_URL}/${identificador}`).pipe(tap(() => this.notifyChange()));
    }

    private notifyChange(): void {
        this._onDesbloqueioChange.next();
    }
}
